export const REVENUE_GRAPH_COLORS = {
  actualRevenue: {
    key: 'actualRevenue',
    fill: '#EDF1FC',
    stroke: '#476FF2'
  },
  underContract: {
    key: 'underContractDiff',
    fill: '#06fdb314',
    stroke: '#00ACB7'
  },
  pipeline: {
    key: 'pipeline',
    fill: '#FFF3E0',
    stroke: '#FF9800'
  },
  revenueGoal: {
    key: 'revenueGoal',
    fill: '#FFFFFF',
    stroke: '#6D6E73'
  }
};
